export function getLocalDatabaseVersion(): number {
  const localDatabaseVersion = localStorage.getItem('local-database-version');
  return localDatabaseVersion ? parseFloat(localDatabaseVersion) : 0.0;
}
